/**
 * @generated SignedSource<<6fc033220088faf47c39682eb1870625>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ModeratorMuteUserInput = {
  set: boolean;
  uuid: string;
};
export type AdminActionsMuteMutation$variables = {
  input: ModeratorMuteUserInput;
};
export type AdminActionsMuteMutation$data = {
  readonly moderatorMuteUser: {
    readonly user: {
      readonly uuid: string | null;
    };
  } | null;
};
export type AdminActionsMuteMutation = {
  variables: AdminActionsMuteMutation$variables;
  response: AdminActionsMuteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ModeratorMuteUserPayload",
    "kind": "LinkedField",
    "name": "moderatorMuteUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uuid",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminActionsMuteMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminActionsMuteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a2b637be74cbc8b1148fe77f02d5a9bb",
    "id": null,
    "metadata": {},
    "name": "AdminActionsMuteMutation",
    "operationKind": "mutation",
    "text": "mutation AdminActionsMuteMutation(\n  $input: ModeratorMuteUserInput!\n) {\n  moderatorMuteUser(input: $input) {\n    user {\n      uuid\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6b956d5cb44db376158fff80cef39499";

export default node;
